<div class="row mt-3" *ngIf="erro && !carregando">
  <div class="col-lg-12">
    <nb-card class="card-erro">
      <nb-card-body>{{ erro }}</nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row mt-3" *ngIf="carregando">
  <div class="col-lg-12">
    <nb-card>
      <nb-card-body class="carregando-box">
        <nb-spinner status="primary"></nb-spinner>
        <span>Carregando matriz de frequência…</span>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row mt-3" *ngIf="dados && !carregando">
  <div class="col-lg-12">
    <p class="toolbar-top">
      <button nbButton size="small" status="basic" outline type="button" (click)="irFrequenciaDia()">
        <nb-icon pack="eva" icon="calendar-outline"></nb-icon>
        Ir para frequência (por data)
      </button>
      <button nbButton size="small" status="basic" outline type="button" (click)="irFaltasConsolidado()">
        <nb-icon pack="eva" icon="bar-chart-outline"></nb-icon>
        Faltas consolidadas
      </button>
      <button nbButton size="small" status="basic" ghost type="button" (click)="carregar()" class="btn-atualizar">
        <nb-icon pack="eva" icon="refresh-outline"></nb-icon>
        Atualizar
      </button>
    </p>

    <nb-card>
      <nb-card-header>
        <div class="cabecalho-matriz">
          <div>
            <span class="subtitulo">Matriz de frequência</span>
            <h3 class="nome-turma">{{ dados.turmaNome || 'Turma ' + turmaId }}</h3>
            <span class="data-leg" *ngIf="exibeMissa">
              Itinerário com frequência em missa — o ponto ao lado da presença indica missa.
            </span>
          </div>
          <div class="resumo">
            <span><strong>{{ catequizandos.length }}</strong> catequizandos</span>
            <span class="sep">·</span>
            <span><strong>{{ dados.totalEncontros }}</strong> encontros</span>
          </div>
        </div>

        <div class="legenda">
          <span class="legenda-item"><span class="celula presente">P</span> presente</span>
          <span class="legenda-item"><span class="celula falta">F</span> falta</span>
          <span class="legenda-item"><span class="celula falta virtual">F</span> falta sem registro</span>
          <span class="legenda-item" *ngIf="exibeMissa"><span class="celula presente com-missa">P</span> presente + missa</span>
        </div>
      </nb-card-header>

      <nb-card-body>
        <div class="matriz-scroll" *ngIf="catequizandos.length && datas.length">
          <table class="matriz">
            <thead>
              <tr>
                <th class="col-num">#</th>
                <th class="col-nome">Catequizando</th>
                <th class="col-data" *ngFor="let d of datas; trackBy: trackByData">
                  <a
                    class="link-data"
                    [routerLink]="['/frequencia', turmaId]"
                    [queryParams]="{ data: d }"
                    [attr.title]="'Abrir a chamada de ' + (paraData(d) | date: 'dd/MM/yyyy')"
                  >
                    <span class="dia">{{ paraData(d) | date: 'dd/MM' }}</span>
                    <span class="ano">{{ paraData(d) | date: 'yy' }}</span>
                  </a>
                </th>
                <th class="col-total">P</th>
                <th class="col-total">F</th>
                <th class="col-total" *ngIf="exibeMissa">Missa</th>
                <th class="col-total col-pct">%</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let c of catequizandos; let i = index; trackBy: trackByPessoa">
                <td class="col-num">{{ i + 1 }}</td>
                <td class="col-nome" [attr.title]="c.pessoaNome">{{ c.pessoaNome }}</td>

                <td class="col-data" *ngFor="let cel of c.frequencias; trackBy: trackByCelula">
                  <span
                    class="celula"
                    [class.presente]="cel.presente"
                    [class.falta]="!cel.presente"
                    [class.virtual]="cel.virtual"
                    [class.com-missa]="exibeMissa && cel.presenteMissa"
                    [attr.title]="rotuloCelula(cel, c.pessoaNome)"
                  >
                    {{ cel.presente ? 'P' : 'F' }}
                  </span>
                </td>

                <td class="col-total total-presencas">{{ c.totalPresencas }}</td>
                <td class="col-total total-faltas">{{ c.totalFaltas }}</td>
                <td class="col-total" *ngIf="exibeMissa">{{ c.totalPresencasMissa }}</td>
                <td class="col-total col-pct" [class.baixa]="percentual(c) < 75">{{ percentual(c) }}%</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td class="col-num"></td>
                <td class="col-nome">Presentes no encontro</td>
                <td class="col-data" *ngFor="let d of datas; let j = index; trackBy: trackByData">
                  {{ presencasNaData(j) }}
                </td>
                <td class="col-total" [attr.colspan]="exibeMissa ? 4 : 3"></td>
              </tr>
            </tfoot>
          </table>
          <div class="fim-scroll-bar" aria-hidden="true"></div>
        </div>

        <p class="vazio" *ngIf="!catequizandos.length">Nenhum catequizando matriculado nesta turma.</p>
        <p class="vazio" *ngIf="catequizandos.length && !datas.length">
          Nenhuma chamada registrada nesta turma ainda.
        </p>
      </nb-card-body>
    </nb-card>
  </div>
</div>
